/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckRuleType {
    ENTRY = 'ENTRY',
    TRANSIT = 'TRANSIT',
    EXIT = 'EXIT'
}


export function instanceOfPaxCheckRuleType(value: any): boolean {
    for (const key in PaxCheckRuleType) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckRuleType, key)) {
            if (PaxCheckRuleType[key as keyof typeof PaxCheckRuleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckRuleTypeFromJSON(json: any): PaxCheckRuleType {
    return PaxCheckRuleTypeFromJSONTyped(json, false);
}

export function PaxCheckRuleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRuleType {
    return json as PaxCheckRuleType;
}

export function PaxCheckRuleTypeToJSON(value?: PaxCheckRuleType | null): any {
    return value as any;
}

export function PaxCheckRuleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckRuleType {
    return value as PaxCheckRuleType;
}

